<p>
  {{message$ | async}}
</p>
